import { Fonts, mediaQuery, Spacings } from '@styles/index';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';
import Image from '@base/Image';

const HR = styled.hr`
  border-top: 1px solid var(--color-divider);
`;

const Wrapper = styled.div`
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_4B};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${mediaQuery.aboveMobile} {
    max-width: 500px;
    margin: ${Spacings.SPACING_16B} auto;
  }
`;

const Heading = styled.div`
  font-size: 22px;
  font-weight: ${Fonts.HEAVY};
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_1B};
`;

const Description = styled(P1)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const StyButton = styled(Button)``;

const StartignPrice = styled(P2)`
  margin-top: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.SEMIBOLD};
`;

const Divider = styled.div`
  height: ${Spacings.SPACING_2B};
  background-color: var(--color-divider);
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

const TrialOver = ({ subscription, grantResponse }) => {
  const handleGetSubscription = () => {
    window.open(`${subscription.relativeLink}/subscribe`, '_blank');
  };

  return (
    <>
      <HR />
      <Wrapper>
        <Image
          src="/free-trial/expiry.svg"
          alt="status"
          width="120"
          height="120"
        />
        <Heading>Your free trial is over</Heading>
        <Description>
          Upgrade your subscription to get continued access to the to high
          quality lectures, notes, tests
        </Description>
        <StyButton
          onClick={handleGetSubscription}
          label="Get subscription"
          width="100%"
        />
        {grantResponse?.subscription_lowest_price && (
          <StartignPrice>
            Starts from ₹{grantResponse.subscription_lowest_price}/mo
          </StartignPrice>
        )}
      </Wrapper>
      <Divider />
    </>
  );
};

export default TrialOver;
